import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ShiftSection } from './components/ShiftSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { PainPointsSection } from './components/PainPointsSection';
import { VolumesSection } from './components/VolumesSection';
import { ExtrasSection } from './components/ExtrasSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FaqSection } from './components/FaqSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
interface AppProps {
  showFloatingCta?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showFloatingCta = true,
  showPurchaseNotifications = true
}: AppProps = {}) {
  return <div className="w-full bg-cream-100" data-id="element-0" data-mp="3recbnd7qcbci">
      <MetaPixel data-id="element-1" data-mp="67yhm9c7y5s" />

      <Hero data-id="element-2" data-mp="4n5i12o8na1" />

      <main data-id="element-3" data-mp="5gbgztt38r4">
        <ProblemSection data-id="element-4" data-mp="82k72sfnuax" />
        <ShiftSection data-id="element-5" data-mp="2zld0z6e9z99y" />
        <BeforeAfterSection data-id="element-6" data-mp="2zlv8x0aavbxp" />
        <PainPointsSection data-id="element-7" data-mp="2zmo5x9jgin2n" />
        <VolumesSection data-id="element-8" data-mp="2zng1wlgyumtg" />
        <ExtrasSection data-id="element-9" data-mp="33m5cy7ej7s9x" />
        <BonusesSection data-id="element-10" data-mp="33nges1of2pye" />
        <OfferSection data-id="element-11" data-mp="33mylndx1wrup" />
        <GuaranteeSection data-id="element-12" data-mp="38lrnua6w0wfk" />
        <TestimonialsSection data-id="element-13" data-mp="38li95irambp6" />
        <AboutSection data-id="element-14" data-mp="38k6uup081ljt" />
        <FaqSection data-id="element-15" data-mp="38nulngea7tuu" />
        <FinalCTASection data-id="element-16" data-mp="3dkl42adk71jf" />
      </main>

      <Footer data-id="element-17" data-mp="3dlnu6g324zya" />

      {showFloatingCta ? <FloatingCTA data-id="element-18" data-mp="3dirxsw6uyjby" /> : null}
      {showPurchaseNotifications ? <PurchasePopup data-id="element-19" data-mp="nuhj4kutefvc" /> : null}
    </div>;
}